import api from '../../components/api'
import {
  FeatureFlag,
  FeatureFlagSaveInput,
  Segment,
  SegmentSaveInput,
} from './featureFlags'

export type FeaturesResponse = {
  features: FeatureFlag[]
  mySegments: string[]
}

export const getFeatures = async (): Promise<FeaturesResponse> => {
  return (await api.get<FeaturesResponse>('/features')).data
}

export const reportFeatureFlagUsage = async (featureId: string, treatment: string): Promise<void> => {
  await api.post('/features/traffic', { featureId, treatment })
}

export const getSegments = async (): Promise<Segment[]> => {
  return (await api.get<Segment[]>('/features/segments')).data
}

export const saveFeatureFlag = async (id: string, input: FeatureFlagSaveInput): Promise<void> => {
  await api.put(`/features/${encodeURIComponent(id)}`, input)
}

export const deleteFeatureFlag = async (id: string): Promise<void> => {
  await api.delete(`/features/${encodeURIComponent(id)}`)
}

export const saveSegment = async (id: string, input: SegmentSaveInput): Promise<void> => {
  await api.put(`/features/segments/${encodeURIComponent(id)}`, input)
}

export const deleteSegment = async (id: string): Promise<void> => {
  await api.delete(`/features/segments/${encodeURIComponent(id)}`)
}
